import React from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import CommonsConstants from "../../commons/configurations/Constants";
import { isEmpty as _isEmpty } from "lodash";
import Translation from "../../commons/i18n/Translation";
import RandomGradient from "../../commons/components/RandomGradient";
import classNames from 'classnames';

import defaultAvatar from "../../../../images/mywort/default-avatar.png";
import Svg from "../../../svg/Svg";

const LAYOUTS = {
    SMALL: "small",
    DEFAULT: "default",
    FULL: "full"
};

export default class Post extends React.Component {

    static defaultProps = {
        layout                  : LAYOUTS.DEFAULT,
        publisherAvatarUri      : defaultAvatar
    };

    static propTypes = {
        publisherAvatarUri      : PropTypes.string,
        publisherPermalink      : PropTypes.string.isRequired,
        publisherName           : PropTypes.string.isRequired,
        postId                  : PropTypes.string.isRequired,
        postTitle               : PropTypes.string.isRequired,
        postPermalink           : PropTypes.string.isRequired,
        postType                : PropTypes.string,
        publishedAt             : PropTypes.string.isRequired,
        localityName            : PropTypes.string.isRequired,
        localityPermalink       : PropTypes.string.isRequired,
        teaserPicture           : PropTypes.string,
        videoThumbnail          : PropTypes.string,
        layout                  : PropTypes.string,
        isGroup                 : PropTypes.bool,
        nextOccurrence          : PropTypes.string,
        randomGradient          : PropTypes.number,
        maybeMissionId          : PropTypes.string
    };

    static LAYOUTS = LAYOUTS;

    shouldComponentUpdate(nextProps) {
        return this.props.postId !== nextProps.postId; // For performances reasons
    }

    getTeaserPicture = () => this.props.teaserPicture || this.props.videoThumbnail;

    renderMainPicture = () => this.getTeaserPicture() ? <img src={this.getTeaserPicture()} alt={this.props.postTitle}/> : <RandomGradient imgClassName="u-fluid-image mywort-post__picture--no-picture" randomGradient={this.props.randomGradient}/>;
    renderPublisherAvatar = () => <img src={this.props.publisherAvatarUri} alt={this.props.publisherName} className="mywort-post__avatar"/>;
    renderPublisherName = () => <div className="mywort-post__publisher">{this.props.publisherName}</div>;
    renderGroupName = () => (
        <div className="mywort-post__publisher-group-wrapper">
            <div className="mywort-post__publisher-group">
                <Svg id="fa-users" className="u-text-mywort mywort-post__publisher-group__svg"/>&nbsp;{this.props.publisherName}
            </div>
        </div>
    );


    renderPublisherDefault = () => {
        if(this.props.isGroup){
            return this.renderGroupName()
        }
        return <span>
            { this.renderPublisherAvatar() }
            { this.renderPublisherName() }
        </span>
    };

    renderPublishedAt = () => (
        this.props.publishedAt ?
            <div className="mywort-post__footer-published-at left">
                { Moment(this.props.publishedAt).format(CommonsConstants.SIMPLE_DATE_DISPLAY_FORMAT[Translation.getLanguageName()]) }
            </div> : null
    );

    renderEventWatermark = () => {
        if(!this.props.nextOccurrence)
            return null;

        let day = Moment(this.props.nextOccurrence, "YYYY-MM-DD");
        return <div className="mywort-post__date">
            { day.format("DD") }
            <div className="mywort-post__date-month">{day.format("MMM")}</div>
        </div>
    };

    svgMarkup(postType) {
        const mywortSvgWatermark = '<svg class="watermark watermark--'+ postType + '"><use xlink:href="#watermark-' + postType + '"></use></svg>';
        return {__html: mywortSvgWatermark};
    }

    renderPostTypeWatermark = () => {
        if(this.props.nextOccurrence)
            return null;

        if(this.props.maybeMissionId){
            return <span className={`watermark watermark--teaser mywortMission`}/>;
        }

        if(_isEmpty(this.props.postType))
            return null;

        return <div dangerouslySetInnerHTML={this.svgMarkup(this.props.postType)}/>
    };

    renderPostTitle = () => (
        <header>
            <h3 className="mywort-post__title u-text-center-v">
                <a className="mywort-post__title-inside mywort-post__link" href={this.props.postPermalink}>{this.props.postTitle}</a>
            </h3>
        </header>
    );

    renderLocality = () => (
        <div className="mywort-post__footer-locality right">
            <a className="mywort-post__link" href={this.props.localityPermalink}>{this.props.localityName}</a>
        </div>
    );

    renderDefaultLayout = () => {
        let postOrEventClass = classNames('mywort-post mywort-post--default', {'mywort-post--event': this.props.nextOccurrence});
        return (
            <article className={postOrEventClass}>
                <a className="mywort-post__picture-wrapper" href={this.props.postPermalink}>
                <span className="u-fluid-container">
                    { this.renderMainPicture() }
                </span>
                    { this.renderPostTypeWatermark() }
                    { this.renderEventWatermark() }
                </a>
                <div className="mywort-post__content">
                    <a className="mywort-post__link" href={this.props.publisherPermalink}>
                        { this.renderPublisherDefault() }
                    </a>
                    { this.renderPostTitle() }
                    <div className="mywort-post__footer">
                        { this.renderPublishedAt() }
                        { this.renderLocality() }
                        <div className="u-clear"></div>
                    </div>
                </div>
            </article>
        );
    }

    renderSmallLayout = () => {
        let postOrEventClass = classNames('mywort-post mywort-post--small', {'mywort-post--event': this.props.nextOccurrence});
        return (
            <article className={postOrEventClass}>
                <div className="mywort-post__content">
                    <a className="mywort-post__link" href={this.props.publisherPermalink}>
                        { this.renderPublisherDefault() }
                    </a>
                    { this.renderPostTitle() }
                    <div className="mywort-post__footer">
                        { this.renderPublishedAt() }
                        { this.renderLocality() }
                        <div className="u-clear"></div>
                    </div>
                </div>
            </article>
        );
    };

    renderFullLayout = () => {
        let postOrEventClass = classNames('mywort-post mywort-post--full-condensed', {'mywort-post--event': this.props.nextOccurrence});
        return (
            <article
                className={postOrEventClass}>
                <a className="mywort-post__picture-wrapper mywort-post__link" href={this.props.postPermalink}>
                    { this.renderMainPicture() }
                    { this.renderEventWatermark() }
                    { this.renderPostTypeWatermark() }
                </a>
                <div className="mywort-post__content">
                    <div className="mywort-post__header">
                        <a className="mywort-post__link"
                           href={this.props.publisherPermalink}>{ this.renderPublisherAvatar() }</a>
                        { this.renderPostTitle() }
                    </div>
                    <div className="mywort-post__footer">
                        <div className="mywort-post__publisher left">
                            <a className="mywort-post__link"
                               href={this.props.publisherPermalink}>{ this.renderPublisherName() }</a>
                        </div>
                        { this.renderLocality() }
                    </div>
                </div>
            </article>
        );
    };

    render = () => {
        if(this.props.layout === Post.LAYOUTS.SMALL)
            return this.renderSmallLayout();
        else if(this.props.layout === Post.LAYOUTS.FULL)
            return this.renderFullLayout();
        else
            return this.renderDefaultLayout();
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/Post.jsx